import { Title } from '@solidjs/meta'
import { type Component, createSignal, Show } from 'solid-js'
import { z } from 'zod'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Container from '~/components/Container'
import Form from '~/components/Form'
import Icon from '~/components/Icon' // Reemplazado
import Input from '~/components/Input'
import { useForm } from '~/hooks/useForm'
import ThemeToggle from '~/layers/ThemeToggle'
import { useNavigate } from '~/router'

const recoverSchema = z.object({
  email: z.string().min(1, 'Por favor ingrese su correo electrónico').email('Correo electrónico inválido')
})

const RecuperarPage: Component = () => {
  const navigate = useNavigate()
  const [error, setError] = createSignal('')
  const [success, setSuccess] = createSignal('')

  const form = useForm({
    schema: recoverSchema,
    initialValues: { email: '' },
    onSubmit: async () => {
      setError('')
      setSuccess('')

      // Simulamos un pequeño retraso para mostrar el estado de carga
      await new Promise(resolve => setTimeout(resolve, 1000))

      // Aquí iría la lógica real de recuperación
      setSuccess('Se han enviado las instrucciones a tu correo electrónico')
    },
    onError: err => setError(err instanceof Error ? err.message : 'Error al procesar la solicitud')
  })

  return (
    <>
      <Title>Recuperar Contraseña | Florez Jaramillo</Title>
      <div class="h-[100dvh] w-full bg-background overflow-y-auto">
        <Container class="min-h-full py-8 flex items-center">
          <div class="w-full max-w-md mx-auto">
            <Card class="p-6">
              <div class="absolute top-4 right-4">
                <ThemeToggle />
              </div>

              <div class="text-center mb-8">
                <div class="w-24 h-24 bg-primary-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Icon icon="material-symbols-light:security" class="text-white" size={64} />
                </div>
                <h1 class="text-2xl font-bold text-foreground mb-2">¿Olvidaste tu contraseña?</h1>
                <p class="text-foreground-subtle">Ingresa tu correo electrónico para recuperarla</p>
              </div>

              <Show when={error()}>
                <div class="mb-6 p-3 bg-danger-soft border-danger-soft text-on-danger-soft rounded-lg">{error()}</div>
              </Show>

              <Show when={success()}>
                <div class="mb-6 p-3 bg-success-soft border-success-soft text-on-success-soft rounded-lg">{success()}</div>
              </Show>

              <Form controller={form} class="space-y-6">
                <Input
                  name="email"
                  type="email"
                  label="Correo electrónico"
                  placeholder="correo@ejemplo.com"
                  disabled={form.submitting()}
                  autocomplete="email"
                  endIcon="material-symbols-light:mail-outline"
                />

                <Button type="submit" color="primary" class="w-full py-3 flex justify-center" disabled={form.submitting() || !form.valid()}>
                  {form.submitting() ? (
                    <>
                      <div class="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-border border-t-foreground"></div>
                      Procesando...
                    </>
                  ) : (
                    'Enviar instrucciones'
                  )}
                </Button>

                <div class="text-center mt-4">
                  <Button type="button" variant="text" startIcon="material-symbols-light:chevron-left" color="secondary" onClick={() => navigate('/login')} class="text-sm">
                    Volver al inicio de sesión
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </Container>
      </div>
    </>
  )
}

export default RecuperarPage
